import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";

export type ShopEntryContext = {
  email: string;
  planType: "GUARANTEED_SEATS" | "ZONE_BASED" | "BEST_AVAILABLE";
  slug: string;
  createdAt: number;
};

const KEY = "shopEntryContext";

const safeParse = <T,>(value: string | null): T | null => {
  if (!value) return null;
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
};

export const getShopEntryContext = async (): Promise<ShopEntryContext | null> => {
  if (Platform.OS === "web") {
    const storage = typeof window !== "undefined" ? window.sessionStorage : null;
    return safeParse<ShopEntryContext>(storage?.getItem(KEY) ?? null);
  }

  const value = await AsyncStorage.getItem(KEY);
  return safeParse<ShopEntryContext>(value);
};

export const setShopEntryContext = async (
  value: ShopEntryContext | null
): Promise<void> => {
  if (Platform.OS === "web") {
    const storage = typeof window !== "undefined" ? window.sessionStorage : null;
    if (!storage) return;
    if (value === null) storage.removeItem(KEY);
    else storage.setItem(KEY, JSON.stringify(value));
    return;
  }

  if (value === null) {
    await AsyncStorage.removeItem(KEY);
  } else {
    await AsyncStorage.setItem(KEY, JSON.stringify(value));
  }
};

